import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    systemList: JSON.parse(sessionStorage.getItem('systemList') || '[]'),
    username: sessionStorage.getItem('username'),
    token: sessionStorage.getItem('token'),
    userId: sessionStorage.getItem('userId'),
  },
  // mutations同步操作数据的方法
  mutations: {
    // 菜单树数据
    setSystemList(state, data) {
      state.systemList = data
      sessionStorage.setItem('systemList', JSON.stringify(data))
    },
    setUsername(state, data) {
      state.username = data
      sessionStorage.setItem('username', data)
    },
    setUserId(state, data) {
      state.userId = data
      sessionStorage.setItem('userId', data)
    },
    setToken(state, data) {
      state.token = data
      sessionStorage.setItem('token', data)
    },
  },
  actions: {

  },
  getters: {
    systemList: (state) => {
      return state.systemList;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js